module.exports = __webpack_public_path__ + "img/icon_mall_jp.09791745.svg";